import { QUESTIONNAIRE_RECRUITMENT_TYPES } from './questionnaire.enums';

import { NON_SALES_INDUSTRY_PROFESSIONAL_QUESTIONS } from './non-sales-industry-professional';
import { SALES_INDUSTRY_PROFESSIONAL_QUESTIONS } from './sales-industry-professional';
import { SCHOOL_LEAVERS_QUESTIONS } from './school-leavers';

export * from './questionnaire.enums';
export * from './non-sales-industry-professional';
export * from './sales-industry-professional';
export * from './school-leavers';


export const QUESTIONNAIRE_QUESTION_SETS = {
  [QUESTIONNAIRE_RECRUITMENT_TYPES.SCHOOL_LEAVER]: SCHOOL_LEAVERS_QUESTIONS,
  [QUESTIONNAIRE_RECRUITMENT_TYPES.SALES_INDUSTRY_PROFESSIONAL]:
    SALES_INDUSTRY_PROFESSIONAL_QUESTIONS,
  [QUESTIONNAIRE_RECRUITMENT_TYPES.NON_SALES_INDUSTRY_PROFESSIONAL]:
    NON_SALES_INDUSTRY_PROFESSIONAL_QUESTIONS,
};

const normalise = (value: string) =>
  (value ?? '').toString().trim().toLowerCase();


export const getQuestionnaireQuestions = (recruitmentType: string) => {
  const wanted = normalise(recruitmentType);
  if (!wanted) return [];

  const match = Object.keys(QUESTIONNAIRE_QUESTION_SETS).find(
    (type) => normalise(type) === wanted
  );

  return match ? QUESTIONNAIRE_QUESTION_SETS[match] : [];
};
